import {
  BatchLoadExperimentsData,
  Entry,
  EValidationResult,
} from 'business/models/Models';
import { FmlxTooltip, FmlxTableCell, FmlxTableRow } from 'fmlx-common-ui';
import React, { useCallback } from 'react';
import { ColumnDef } from './BatchloadTable';

type BatchloadTableRowProps = {
  rowIndex: number;
  rowData: BatchLoadExperimentsData;
  rowColumns: ColumnDef[];
  id?: string;
};

const BatchloadTableRow = ({
  rowIndex,
  rowData,
  rowColumns,
  id,
}: BatchloadTableRowProps) => {
  const TEXT_WRAP = {
    wrap: 'whitespace-normal',
    noWrap: 'whitespace-nowrap',
  } as const;

  const getStatusColor = (
    result?: EValidationResult,
    enableValidColor: boolean = false,
  ) => {
    switch (result) {
      case EValidationResult.Valid:
        return enableValidColor ? '#3F9243' : '#000000';
      case EValidationResult.Warning:
        return '#F7A246';
      case EValidationResult.Invalid:
        return '#DB0000';
      default:
        return '#000000';
    }
  };

  const getCell = useCallback(
    (
      column: ColumnDef,
      data: Entry | undefined,
      rowIndex: number,
      columnIndex: number,
    ) => {
      const getId = (componentName: string) => {
        const idSuffix = `row${rowIndex}-col${column.id ?? columnIndex}`;
        return `${id ?? ''}${componentName}-${idSuffix}`;
      };
      return (
        <FmlxTooltip title={data?.validation?.message ?? ''}>
          <FmlxTableCell
            id={getId('fmlxtablecell')}
            key={getId('fmlxtablecell')}
            align={column.textAlign ?? 'left'}
            sx={{
              whiteSpace: 'nowrap',
              ...(data?.validation?.result !== EValidationResult.Valid &&
                column.showStatusBorder && {
                  borderColor:
                    data?.validation != null
                      ? getStatusColor(data?.validation?.result, false)
                      : '#000000',
                  borderStyle: 'solid',
                  borderWidth: 1,
                  borderTopWidth: 0.5,
                  borderBottomWidth: 0.5,
                }),
            }}
          >
            <span
              id={getId('fmlxtablecell-span')}
              key={getId('fmlxtablecell-span')}
              className={`${!column.showStatusBorder ? 'font-bold' : ''} ${
                TEXT_WRAP[column.textWrap ?? 'noWrap']
              } text-xs`}
              style={{
                color: !column.showStatusBorder
                  ? getStatusColor(data?.validation?.result, true)
                  : '#000000',
              }}
            >
              {data?.value ?? ''}
            </span>
          </FmlxTableCell>
        </FmlxTooltip>
      );
    },
    [id],
  );

  return (
    <FmlxTableRow
      id={`${id}-fmlxtablerow-${rowIndex}`}
      key={`${id}-fmlxtablerow-${rowIndex}`}
      onClick={null}
      sx={{ height: 40 }}
    >
      {rowColumns.map((column: any, colIdx: number) => {
        return getCell(column, rowData[column.key], rowIndex, colIdx);
      })}
    </FmlxTableRow>
  );
};

export default BatchloadTableRow;
